import { QueryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppDataContext } from '../../contexts/appData';

export const useGetProductRecommendations = ({ productId }) => {
  const { api } = useContext(AppDataContext);

  const { data, refetch, isLoading, isPending, isFetching } = useQuery({
    queryKey: [QueryKeys.ProductAnalyticsRecommendation, productId],
    queryFn: () => api.getProductAnalyticsRecommendations(productId),
    staleTime: 1000 * 60 * 60,
    placeholderData: (previousData) => previousData,
  });

  const recommendations = data?.data || [];

  return { isLoading, refetch, isPending, isFetching, recommendations };
};
